import React, {useEffect, useState} from 'react';
import yacht1 from '../../../../images/yacht1.png'
import yacht2 from '../../../../images/yacht2.png'
import yacht3 from '../../../../images/yacht3.png'
import css from '../Profile.module.scss'
import Yacht from "./Yacht";
import plus from "../../../../images/plus.svg";
import {RemoveScrollBar} from "react-remove-scroll-bar";
import AddYacht from "../../../common/modals/AddYacht";
import CreateModel from "../../../common/modals/CreateModel";
import DeleteYacht from "../../../common/modals/DeleteYacht";
import {useTheme} from "../../../../App";
import {connect} from "react-redux";
import {deleteFavoriteYacht, getFavoriteYachts} from "../../../../redux/profile/profile-thunks";
import {useTranslation} from "react-i18next";

const Yachts = ({isDark, favoriteYachts, profile, getFavoriteYachts, ...props}) => {
  const [isAddModal, setIsAddModal] = useState(false)
  const [isCreateModal, setIsCreateModal] = useState(false)
  const [editYacht, setEditYacht] = useState(null)
  const [deleteYacht, setDeleteYacht] = useState(null)
  const {t} = useTranslation()
  useEffect(() => {
    if (profile) {
      getFavoriteYachts()
    }
  }, [profile])

  return (
    <>
      <div className={`${css.licenses} ${css.yachts}`}>
        {favoriteYachts?.map((yacht, index) => <Yacht isDark={isDark} item={yacht} key={index}
                                                      setEditYacht={setEditYacht}
                                                      setDeleteYacht={setDeleteYacht}/>)}
        {(isAddModal || isCreateModal || editYacht || deleteYacht) && <>
          <RemoveScrollBar/>
          <div className="overlay"/>
        </>}
        {((isAddModal || editYacht) && !isCreateModal) && <AddYacht closeModal={() => {
          setEditYacht(null)
          setIsAddModal(false)
        }} editYacht={editYacht} openCreateModal={() => {
          setIsCreateModal(true)
        }}/>}
        {isCreateModal && <CreateModel closeModal={() => {
          setIsCreateModal(false)
          setIsAddModal(true)
        }}/>}
        {deleteYacht && <DeleteYacht deleteItem={deleteYacht} closeModal={() => setDeleteYacht(null)}
                                     onDelete={() => props.deleteFavoriteYacht(deleteYacht?.yacht?.id)}/>}
        <button onClick={() => {
          if(props.user?.is_active) {
            setIsAddModal(true)
          } else {
            props.openConfirmEmail()
          }
        }} className={`empty__plus addButton`}>
          <img src={plus} alt=""/>
        </button>
      </div>
      {(favoriteYachts !== null && props.isMoreYachts) && <div className="showMore__wrapper">
        <button onClick={() => getFavoriteYachts(favoriteYachts.length)} className="showMore">{t('showMore')}</button>
      </div>}
    </>
  );
};

const mapStateToProps = (state) => ({
  favoriteYachts: state.profileReducer.favoriteYachts,
  profile: state.userReducer.profile,
  user: state.userReducer.user,
  isMoreYachts: state.profileReducer.isMoreYachts
})

export default connect(mapStateToProps, {getFavoriteYachts, deleteFavoriteYacht})(React.memo(Yachts))
